module.exports = __webpack_public_path__ + "img/violet_049.97385f23.png";